import Link from 'next/link'

import Logo from 'components/Logo'

import styles from './MarketingSignupHero.module.css'

export type MarketingSignupHeroProps = {
  imageUrl: string
  heading: string
  subheading: string
  wrongAccount?: React.ReactNode
}

const MarketingSignupHero = ({ imageUrl, heading, subheading, wrongAccount }: MarketingSignupHeroProps) => (
  <div className={styles.container}>
    <img src={imageUrl} alt="" className={styles.background} />

    <div className={styles.content}>
      <Link href="/" passHref>
        <a className={styles.logo}>
          <Logo isReversed />
        </a>
      </Link>

      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>{heading}</h1>

        <h3 className={styles.subheading}>{subheading}</h3>
      </div>

      {wrongAccount && <div className={styles.wrongAccount}>{wrongAccount}</div>}
    </div>
  </div>
)

export default MarketingSignupHero
